module.exports = __webpack_public_path__ + "6cb0bd9962fe6024c6b546c60c93684b.png";